<template>
  <div>
    <CCard>
      <CCol sm="12">
        <CRow>
          <CCol sm="12">
            <CRow class="p-3">
              <CCol sm="12">
                <h5>Learning Center</h5>
                <h6>
                  Register your account by fill all the form in the following
                  below
                </h6>
                <hr />
              </CCol>
              <CCol sm="12">
                Email
                <br />
                <CInput type="text" v-model="Email" />
              </CCol>
              <CCol sm="12">
                Username
                <br />
                <CInput type="text" v-model="Username" />
              </CCol>
              <CCol sm="12">
                Password
                <br />
                <CInput type="password" v-model="PasswordHash" />
              </CCol>
              <hr />
              <CCol sm="12">
                Tuition Center Name
                <br />
                <CInput type="text" v-model="Name" />
              </CCol>
              <CCol sm="12">
                Description
                <br />
                <CInput type="text" v-model="Description" />
              </CCol>
              <CCol sm="12">
                Phone Number
                <br />
                <CInput type="text" v-model="PhoneNumber" />
              </CCol>
              <CCol sm="12">
                Code
                <br />
                <CInput type="number" v-model="Code" />
                </CCol>
                <CCol sm="12">
                Country<br />
                <v-select
                  v-model="selectedCountries"
                  :options="country"
                  label="CountryName"
                ></v-select>
                <br />
                <input
                  type="submit"
                  class="btn btn-success float-right"
                  value="SAVE FORM"
                  @click="SubmitAdmin"
                />
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>
    </CCard>
  </div>
</template>



<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      Email: "",
      Username: "",
      PasswordHash: "",
      TuitionCenterId: "",
      Description: "",
      PhoneNumber: "",
      Code: "",

      selectedCountries: "",
      country: [],
      Name: "",
    };
  },
  async mounted() {
    this.GetCountry();
  },
  methods: {
    GetCountry() {
      this.$API.get(this.$GetListCountry).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.country = response.data;
        }
      });
    },
    async SubmitAdmin() {
      this.Busy = true;
      const formData = new FormData();

      formData.append("Email", this.Email);
      formData.append("Username", this.Username);
      formData.append("PasswordHash", this.PasswordHash);
      formData.append("Description", this.Description);
      formData.append("Name", this.Name);
      formData.append("PhoneNumber", this.PhoneNumber);
      formData.append("Code", this.Code);
      formData.append("TuitionCenterId", this.Code);
      formData.append("CountryId", this.selectedCountries.Id);

      return this.$API
        .post(this.$InsertRegisterAdmin, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success to saved").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog
              .alert("Error to create packagess")
              .then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
</style>

